import * as THREE from 'three';
import type { GameScene } from '../core/Scene';

export class Ground {
  readonly mesh: THREE.Mesh;

  constructor(size: number, color: number = 0x2d5a27) {
    const geometry = new THREE.PlaneGeometry(size, size);
    // PlaneGeometry lies in XY plane by default; rotate to lie flat on XZ (Y=0)
    geometry.rotateX(-Math.PI / 2);

    const material = new THREE.MeshLambertMaterial({ color });
    this.mesh = new THREE.Mesh(geometry, material);
    this.mesh.receiveShadow = false;
  }

  addTo(scene: GameScene): void {
    scene.add(this.mesh);
  }

  dispose(): void {
    (this.mesh.geometry as THREE.BufferGeometry).dispose();
    (this.mesh.material as THREE.Material).dispose();
  }
}
